import React from 'react';
import { withRouter } from "react-router-dom";

import PostPreview from './PostPreview.js';
import Comment from './Comment.js';
import Header from './Header.js';
import SubredditError from './SubredditError.js';

const DEFAULT_SUBREDDIT = 'all';
const IMAGE_ON_LEFT = localStorage.getItem('imageOnLeft') === 'false' ? false : true;
const DARK_MODE = localStorage.getItem('pimentitDarkMode') === 'false' ? false : true;

class RedditComments extends React.Component {
  constructor() {
    super();

    this.state = {
      isLoading: true,
      subredditError: false,
      error: '',
      errorMessage: '',
      post: {},
      comments: [],
      // count: 0,
      imageOnLeft: IMAGE_ON_LEFT,
      darkMode: DARK_MODE,
    }
  }

  fetchData(direction) {
    const subreddit = this.props.match.params.subreddit || DEFAULT_SUBREDDIT;
    const id = this.props.match.params.id;

    this.setState({
      isLoading: true,
    });
    
    fetch(`https://www.reddit.com/r/${subreddit}/comments/${id}/hot/.json?limit=1000&depth=15`)
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          this.setState({
            isLoading: false,
            subredditError: true,
            error: data.error,
            errorMessage: data.message,
            post: {},
            postAuthor: null,
            comments: [],
          })
        } else if (!data[0].data.children) {
          this.setState({
            isLoading: false,
            subredditError: true,
            errorMessage: `r/${subreddit}: there doesn't seem to be anything here.`,
            post: {},
            postAuthor: null,
            comments: [],
          })
        } else {
          this.setState({
            isLoading: false,
            subredditError: false,
            post: data[0].data.children[0],
            postAuthor: data[0].data.children[0].author,
            comments: data[1].data.children,
          });
        }
      })
      .catch(error => {
        if (error === `TypeError: "NetworkError when attempting to fetch resource."`) {
          this.setState({
            isLoading: false,
            subredditError: true,
            errorMessage: `NetworkError when attempting to fetch resource. This probably means you're blocking this website from accessing reddit.com or the subreddit doesn't exist.`,
            post: {},
            comments: [],
          });
        } else {
          this.setState({
            isLoading: false,
            subredditError: true,
            errorMessage: `r/${subreddit}: there doesn't seem to be anything here`,
            posts: [],
            comments: [],
          });
        }
      })
  }

  componentDidMount() {
    this.fetchData();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.match.params.id !== prevState.id) {
      return { id: nextProps.match.params.id };
    } else {
      return null;
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {

      this.fetchData();
    }

    document.title = this.state.post?.data?.title.length > 0 ? `${this.state.post?.data?.title} - pimentit` : 'pimentit'
  }

  handleMorePosts(direction) {
    this.fetchData(direction);
  }

  handleImagePositionChange() {
    localStorage.setItem('imageOnLeft', !this.state.imageOnLeft);
    this.setState({imageOnLeft: !this.state.imageOnLeft})
  }

  handleDarkModeButton() {
    localStorage.setItem('pimentitDarkMode', !this.state.darkMode);
    this.setState({darkMode: !this.state.darkMode})
  }

  render() {
    return (
      <div className={this.state.darkMode && 'dark'}>
        <Header
          at="RedditComments"
          subreddit={this.props.match.params.subreddit || DEFAULT_SUBREDDIT}
          handleImagePositionChange={() => this.handleImagePositionChange()}
          handleDarkModeButton={() => this.handleDarkModeButton()}
          imageOnLeft={this.state.imageOnLeft}
          darkMode={this.state.darkMode}
        />
        {this.state.isLoading &&
          <div className={`
            flex
            items-center
            justify-center
            px-2
            `}>
            <img
              className={`
                w-6
                h-auto
              `}
              src={`/icon-loading.png`}
              alt={`loading icon`}
            />
          </div>
        }
        {this.state.subredditError &&
          <SubredditError error={this.state.error} message={this.state.errorMessage} />
        }
        {!this.state.subredditError && !this.state.isLoading &&
          <>
            <div>
              <ul
                className={`
                  list-none
                `}
              >
                <PostPreview
                  key={this.state.post.data.name}
                  post={this.state.post.data}
                  imageOnLeft={this.state.imageOnLeft}
                  classes={`
                    m-2
                    border-b
                    border
                    border-solid
                    border-gray-400
                    rounded
                  `}
                />
              </ul>
            </div>
            <div
              className={`
                flex
                max-w-full
                pb-10
              `}
            >
              <ul className={`
                max-w-full
                pl-2
              `}>
                {this.state.comments.map(comment => {
                  return (
                    <Comment
                      key={comment.data.id}
                      comment={comment}
                      postAuthor={this.state.post.data.author}
                      parent={this.props.location.pathname}
                    />
                  )
                })}
              </ul>
            </div>
          </>
        }
      </div>
    )
  }
}

export default withRouter(RedditComments);
